import { z } from 'zod'

import { calendarDate, isoDateTime } from '../lib/date'
import { clinicIdSchema } from './clinic'

/**
 * A one-off schedule override row — a staff member's shift at a clinic on a date,
 * overriding the base rotation. This is the exact DB row shape; the joined staff and
 * template (for display) live in `ScheduleOverrideWithRelations` (relations.ts).
 */
export const scheduleOverrideSchema = z.object({
  id: z.uuid(),
  staffId: z.uuid(),
  /** Clinic wall-clock. */
  date: calendarDate,
  clinicId: clinicIdSchema,
  templateId: z.uuid(),
  note: z.string().nullable(),
  /** Staff id of whoever created this override. Null for legacy/seed rows. */
  createdBy: z.uuid().nullable(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
})

export type ScheduleOverride = z.output<typeof scheduleOverrideSchema>
